// src/components/layout/Footer.jsx
import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const Footer = () => {
  const { isDark } = useTheme();
  
  return (
    <footer className={`relative border-t transition-all duration-300 ${
      isDark 
        ? 'bg-black border-white/10' 
        : 'bg-blue-50 border-blue-200'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          
          {/* Company Info */}
          <div>
            <h3 className={`text-2xl font-bold mb-4 ${isDark ? 'text-white' : 'text-blue-700'}`}>
              DOROTS LTD
            </h3>
            <p className={`text-sm leading-relaxed ${isDark ? 'text-gray-400' : 'text-blue-700'}`}>
              Sustainable innovations is our business at DOROTS Ltd.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className={`font-semibold mb-4 ${isDark ? 'text-white' : 'text-blue-700'}`}>
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="/" 
                  className={`text-sm transition-colors ${
                    isDark 
                      ? 'text-gray-400 hover:text-blue-700' 
                      : 'text-blue-700 hover:text-blue-900'
                  }`}
                >
                  Home
                </a>
              </li>
              <li>
                <a 
                  href="/product" 
                  className={`text-sm transition-colors ${
                    isDark 
                      ? 'text-gray-400 hover:text-blue-700' 
                      : 'text-blue-700 hover:text-blue-900'
                  }`}
                >
                  Product
                </a>
              </li>
              <li>
                <a 
                  href="/solutions" 
                  className={`text-sm transition-colors ${
                    isDark 
                      ? 'text-gray-400 hover:text-blue-700' 
                      : 'text-blue-700 hover:text-blue-900'
                  }`}
                >
                  Solutions
                </a>
              </li>
              <li>
                <a 
                  href="/about" 
                  className={`text-sm transition-colors ${
                    isDark 
                      ? 'text-gray-400 hover:text-blue-700' 
                      : 'text-blue-700 hover:text-blue-900'
                  }`}
                >
                  About
                </a>
              </li>
            </ul>
          </div>
          
          {/* Industries */}
          <div>
            <h4 className={`font-semibold mb-4 ${isDark ? 'text-white' : 'text-blue-700'}`}>
              Industries
            </h4>
            <ul className="space-y-2">
              <li className={`text-sm ${isDark ? 'text-gray-400' : 'text-blue-700'}`}>Construction</li>
              <li className={`text-sm ${isDark ? 'text-gray-400' : 'text-blue-700'}`}>Manufacturing</li>
              <li className={`text-sm ${isDark ? 'text-gray-400' : 'text-blue-700'}`}>Mining</li>
              <li className={`text-sm ${isDark ? 'text-gray-400' : 'text-blue-700'}`}>Oil & Gas</li>
              <li className={`text-sm ${isDark ? 'text-gray-400' : 'text-blue-700'}`}>Food Industry</li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h4 className={`font-semibold mb-4 ${isDark ? 'text-white' : 'text-blue-700'}`}>
              Contact
            </h4>
            <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-blue-700'}`}>
              Fort McMurray, Alberta, Canada
            </p>
            {/* Optional: Add email or phone if available */}
            {/* <p className={`text-sm mt-2 ${isDark ? 'text-gray-400' : 'text-blue-700'}`}>
              info@dorots.com
            </p> */}
          </div>
        </div>
        
        {/* Footer Bottom Section */}
        <div className={`pt-8 border-t text-center ${
          isDark ? 'border-white/10' : 'border-blue-200'
        }`}>
          <p className={`text-sm leading-relaxed max-w-3xl mx-auto mb-4 ${
            isDark ? 'text-gray-500' : 'text-blue-700'
          }`}>
            DOROTS Ltd — the leading consulting firm, developing sustainable innovative solutions 
            to meet evolving challenges while unlocking opportunities that suit today's needs, 
            providing potential for future generations.
          </p>
          <p className={`text-xs ${
            isDark ? 'text-gray-600' : 'text-blue-700'
          }`}>
            © {new Date().getFullYear()} DOROTS LTD. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;